module.exports = __webpack_public_path__ + "img/transfer_sesama.e7460e48.png";